import { render, staticRenderFns } from "./award.vue?vue&type=template&id=2e5f8977&"
import script from "./award.vue?vue&type=script&lang=js&"
export * from "./award.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5f8977')) {
      api.createRecord('2e5f8977', component.options)
    } else {
      api.reload('2e5f8977', component.options)
    }
    module.hot.accept("./award.vue?vue&type=template&id=2e5f8977&", function () {
      api.rerender('2e5f8977', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/award.vue"
export default component.exports